import template from '../../mad-id.module.scss';
import animations from '@styles/animations.module.scss'
import { InView } from 'react-intersection-observer';
import style from './problem-section.module.scss'

interface IProblemProps {
    title: string;
    text: string;
}

const ProblemSection = ({ title, text }: IProblemProps) => {
    return (
        <section className={`${template.section}`}>
            <div className={`${template.container} ${template.flex} ${template.flex_spacebetween}`}>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${animations.scroll__animation} ${template.title} ${template.title_medium} ${template.margin_bot30px}`}>
                                {title}
                            </div>
                        )
                    }}
                </InView>
                <div className={`${template.flex} ${template.flex_column} ${style.project__content}`}>
                    <InView triggerOnce={true}>
                        {({ inView, ref, entry }: any) => {
                            if (inView) {
                                entry.target.classList.add(animations.active);
                            }
                            return (
                                <div ref={ref} className={`${animations.scroll__animation} ${template.text} ${template.text_medium}`}>
                                    {text}
                                </div>
                            )
                        }}
                    </InView>
                </div>
            </div>
        </section>
    )
}

export default ProblemSection;
